/** @format */

import React from "react";
import {
  HomePage,
  About,
  Contact,
  Blog,
  BlogDetail,
  Service,
  AboutList,
  Career,
  Login,
  EditBlog,
  CreateBlog,
  ManageBlogs,
  Activity,
  ActivityDetail,
  HumanService,
  StrategyService,
  ManagementService,
  Soko,
} from "../../pages";
import Partner from "../../pages/public/Partners/Partner";
import PartnerDetails from "../../pages/public/Partners/PartnerDetails";
import { path } from "../common/constant";
export const PublicRoutes = [
  {
    path: `${path.common.HOME}`,
    exact: true,
    component: <HomePage />,
    main: () => <HomePage />,
  },
  {
    path: `${path.common.ABOUT}`,
    exact: true,
    component: <About />,
    main: () => <About />,
  },
  {
    path: `${path.common.ABOUTLIST}`,
    exact: true,
    component: <AboutList />,
    main: () => <AboutList />,
  },
  {
    path: `${path.common.BLOG}`,
    exact: true,
    component: <Blog />,
    main: () => <Blog />,
  },

  {
    path: `${path.common.BLOGDETAIL}`,
    exact: true,
    component: <BlogDetail />,
    main: () => <BlogDetail />,
  },

  {
    path: `${path.common.ACTIVITY}`,
    exact: true,
    component: <Activity />,
    main: () => <Activity />,
  },

  {
    path: `${path.common.ACTIVITIY_DETAIL}`,
    exact: true,
    component: <ActivityDetail />,
    main: () => <ActivityDetail />,
  },

  {
    path: `${path.common.SERVICES}`,
    exact: true,
    component: <HumanService />,
    main: () => <HumanService />,
  },
  {
    path: `${path.common.STRATEGY_SERVICE}`,
    exact: true,
    component: <StrategyService />,
    main: () => <StrategyService />,
  },
  {
    path: `${path.common.MANAGEMENT_SERVICE}`,
    exact: true,
    component: <ManagementService />,
    main: () => <ManagementService />,
  },
  {
    path: `${path.common.CAREER}`,
    exact: true,
    component: <Career />,
    main: () => <Career />,
  },
  // {
  //   path: `${path.common.SOKO}`,
  //   exact: true,
  //   component: <Soko />,
  //   main: () => <Soko />,
  // },
  // {
  //   path: `${path.BLOG_LIST}`,
  //   exact: true,
  //   component: <BlogList />,
  //   main: () => <BlogList />,
  // },
  {
    path: `${path.common.CONTACT}`,
    exact: true,
    component: <Contact />,
    main: () => <Contact />,
  },
  // {
  //   path: `${path.ERROR}`,
  //   exact: true,
  //   component: <NotFoundPage />,
  //   main: () => <NotFoundPage />,
  // },
  {
    path: `${path.common.PARTNERS}`,
    exact: true,
    component: <Partner />,
    main: () => <Partner />,
  },
  {
    path: `${path.common.PARTNER_DETAILS}`,
    exact: true,
    component: <PartnerDetails />,
    main: () => <PartnerDetails />,
  },

  {
    path: `${path.common.ADMIN}`,
    exact: true,
    component: <Login />,
    main: () => <Login />,
  },

  // {
  //   path: `${path.private.MANAGEBLOG}`,
  //   exact: true,
  //   component: <ManageBlogs />,
  //   main: () => <ManageBlogs />,
  //   // role: [allowedRoles[0]],
  // },
  // {
  //   path: `${path.private.CREATEBLOG}`,
  //   exact: true,
  //   component: <CreateBlog />,
  //   main: () => <CreateBlog />,
  //   // role: [allowedRoles[0]],
  // },
  // {
  //   path: `${path.private.EDITNLOG}`,
  //   exact: true,
  //   component: <EditBlog />,
  //   main: () => <EditBlog />,
  //   // role: [allowedRoles[0]],
  // },
];
